import { SITE } from './useMeta';
import { SCHOOL } from './constants';

/**
 * Shared Service schema builder for program pages.
 * Only verifiable, non-fabricated properties are included.
 */
export function serviceSchema({ name, description, slug, serviceType }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name,
    serviceType: serviceType || name,
    description,
    url: `${SITE.url}${slug}`,
    areaServed: {
      '@type': 'City',
      name: 'Colorado Springs',
      containedInPlace: { '@type': 'State', name: 'Colorado' },
    },
    provider: {
      '@type': 'LocalBusiness',
      name: SCHOOL.name,
      telephone: SCHOOL.phone,
      address: {
        '@type': 'PostalAddress',
        streetAddress: '2380 Montebello Dr. W',
        addressLocality: 'Colorado Springs',
        addressRegion: 'CO',
        postalCode: '80918',
        addressCountry: 'US',
      },
      url: SITE.url,
    },
  };
}
